import component from './fr-FR/component';
import globalHeader from './fr-FR/globalHeader';
import menu from './fr-FR/menu';
import pages from './fr-FR/pages';
import pwa from './fr-FR/pwa';
import settingDrawer from './fr-FR/settingDrawer';
import settings from './fr-FR/settings';
import fixOverlay from './fr-FR/fix_overlay';
import fixOpenapi from './fr-FR/fix_openapi';
import fixAdminMisc from './fr-FR/fix_adminmisc';
import fixBilling from './fr-FR/fix_billing';
import fixComponents from './fr-FR/fix_components';
import fixConsoleMisc from './fr-FR/fix_consolemisc';
import fixGap from './fr-FR/fix_gap';
import fixSystemconfig from './fr-FR/fix_systemconfig';
import fixTenant from './fr-FR/fix_tenant';
import fixVoiceClone from './fr-FR/fix_voiceclone';
import fixTodo from './fr-FR/fix_todo';
import fixLedger from './fr-FR/fix_ledger';


export default {
  'navBar.lang': 'Langue',
  'layout.user.link.help': 'Aide',
  'layout.user.link.privacy': 'Confidentialit��',
  'layout.user.link.terms': 'Conditions',
  'app.preview.down.block': 'T��l��charger cette page dans le projet local',
  'app.welcome.link.fetch-blocks': 'Obtenir tous les blocs',
  'app.welcome.link.block-list': 'Cr��ez des pages standards rapidement en utilisant le framework de d��veloppement de blocs',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
